module.exports = __webpack_public_path__ + "img/UTREDF-4.57d585e4.jpg";